/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.io = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init();
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: `0px 0px 500px 0px` });

      this.io.observe(this);
    }
    init() {
      if (this.dataset.autoReset === 'midnight-ny') {
        this.countDownDate = CountdownTimer.getNextMidnightNY();
        return;
      }

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour = 0,
        tarmin = 0;

      if (time) {
        [tarhour, tarmin] = time.split(':').map(Number);
      }

      // Set the date we're counting down to
      let date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;
      // Time without timezone
      this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();

      // Time with timezone
      this.countDownDate = new Date(date_string).getTime();
    }
    static getNextMidnightNY() {
      const now = new Date();
      const tz = 'America/New_York';
      const timeParts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      }).formatToParts(now);
      const get = type => {
        let val = parseInt(timeParts.find(p => p.type === type).value);
        if (type === 'hour' && val === 24) val = 0;
        return val;
      };
      const nyYear = get('year'), nyMonth = get('month'), nyDay = get('day');
      const nyHour = get('hour'), nyMinute = get('minute'), nySecond = get('second');
      // Compute current NY offset from UTC
      const nyAsUTC = Date.UTC(nyYear, nyMonth - 1, nyDay, nyHour, nyMinute, nySecond);
      const offset = now.getTime() - nyAsUTC;
      // Next midnight (00:00:00) in NY as UTC timestamp
      return Date.UTC(nyYear, nyMonth - 1, nyDay + 1, 0, 0, 0) + offset;
    }
    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      return date;
    }
    connectedCallback() {

      const daysEl = this.querySelector('.days .countdown-timer--column--number'),
        hoursEl = this.querySelector('.hours .countdown-timer--column--number'),
        minutesEl = this.querySelector('.minutes .countdown-timer--column--number'),
        secondsEl = this.querySelector('.seconds .countdown-timer--column--number');

      // Wrap each number in a clip container with an initial current span.
      // The clip container gets overflow:hidden; the number element keeps its
      // :before colon pseudo-element outside the clipping context.
      [daysEl, hoursEl, minutesEl, secondsEl].filter(Boolean).forEach(el => {
        const clip = document.createElement('span');
        clip.className = 'countdown-clip';
        const current = document.createElement('span');
        current.className = 'countdown-num--current';
        current.textContent = el.textContent;
        el.textContent = '';
        clip.appendChild(current);
        el.appendChild(clip);
      });

      const updateTime = () => {
        // Wait until init() has set countDownDate via IntersectionObserver
        if (!this.countDownDate) {
          requestAnimationFrame(updateTime);
          return;
        }

        // Get todays date and time
        const now = Date.now();

        // Find the distance between now an the count down date
        const distance = this.countDownDate - now;

        if (distance < 0) {
          if (this.dataset.autoReset === 'midnight-ny') {
            this.countDownDate = CountdownTimer.getNextMidnightNY();
            requestAnimationFrame(updateTime);
            return;
          }
          CountdownTimer.setNumber(daysEl, '00');
          CountdownTimer.setNumber(hoursEl, '00');
          CountdownTimer.setNumber(minutesEl, '00');
          CountdownTimer.setNumber(secondsEl, '00');
          return;
        }

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);

        requestAnimationFrame(updateTime);

        CountdownTimer.setNumber(daysEl, CountdownTimer.addZero(days));
        CountdownTimer.setNumber(hoursEl, CountdownTimer.addZero(hours));
        CountdownTimer.setNumber(minutesEl, CountdownTimer.addZero(minutes));
        CountdownTimer.setNumber(secondsEl, CountdownTimer.addZero(seconds));

      };
      requestAnimationFrame(updateTime);
    }
    static setNumber(el, newVal) {
      if (!el) return;
      newVal = String(newVal);
      const clip = el.querySelector('.countdown-clip');
      const entering = clip.querySelector('.countdown-num--entering');
      const current = clip.querySelector('.countdown-num--current');
      // Guard: already showing or already animating to this value
      if ((entering || current) && (entering || current).textContent === newVal) return;

      // Cancel any in-flight animations
      const leaving = clip.querySelector('.countdown-num--leaving');
      if (leaving) leaving.remove();
      if (entering) entering.remove();

      // Animate current out
      if (current) {
        current.className = 'countdown-num--leaving';
        current.addEventListener('animationend', () => current.remove(), { once: true });
      }

      // Animate new value in
      const next = document.createElement('span');
      next.className = 'countdown-num--entering';
      next.textContent = newVal;
      clip.appendChild(next);

      next.addEventListener('animationend', () => {
        next.className = 'countdown-num--current';
      }, { once: true });
    }
    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}

/**
 *  @class
 *  @function OfferCounter
 *  Deterministic "remaining offers" counter: every visitor on any device sees
 *  the same number because the drop schedule is computed from a seed derived
 *  from (startCount, startTs, endTs). Drops are biased toward US-Eastern
 *  active hours (9:00–22:00) and happen in batches of 1 (70%) or 2 (30%).
 */
if (!customElements.get('offer-counter')) {
  class OfferCounter extends HTMLElement {
    constructor() {
      super();
      this.io = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init();
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px 500px 0px' });
      this.io.observe(this);
    }
    init() {
      const timezone = this.dataset.timezone;
      const [sd, sm, sy] = this.dataset.startDate.split('-').map(Number);
      const [sh, smin] = this.dataset.startTime.split(':').map(Number);
      const [ed, em, ey] = this.dataset.endDate.split('-').map(Number);
      const [eh, emin] = this.dataset.endTime.split(':').map(Number);
      const startCount = Math.max(1, Math.min(10000, parseInt(this.dataset.startCount, 10) || 100));

      const startStr = sm + '/' + sd + '/' + sy + ' ' + sh + ':' + smin + ' GMT' + timezone;
      const endStr = em + '/' + ed + '/' + ey + ' ' + eh + ':' + emin + ' GMT' + timezone;
      this.startTs = new Date(startStr).getTime();
      this.endTs = new Date(endStr).getTime();
      this.startCount = startCount;

      if (!(this.endTs > this.startTs)) {
        // Misconfigured dates — just render the starting number and stop.
        return;
      }

      this.schedule = OfferCounter.buildSchedule(startCount, this.startTs, this.endTs);
      this.numEl = this.querySelector('.countdown-offer--number');
      this.tick();
    }
    static buildSchedule(count, startTs, endTs) {
      const seed = OfferCounter.hash32(count + '|' + startTs + '|' + endTs);
      const rand = OfferCounter.mulberry32(seed);
      const duration = endTs - startTs;
      const events = [];
      let remaining = count;
      const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', hour: 'numeric', hour12: false
      });
      const etHour = (ts) => {
        const h = parseInt(fmt.format(new Date(ts)), 10);
        return isNaN(h) ? 12 : h % 24;
      };
      let guard = count * 20 + 50;
      while (remaining > 0 && guard-- > 0) {
        // Rejection-sample a timestamp biased toward ET 9:00–22:00
        let t = startTs + rand() * duration;
        let tries = 40;
        while (tries-- > 0) {
          const h = etHour(t);
          const weight = (h >= 9 && h <= 22) ? 1.0 : 0.2;
          if (rand() < weight) break;
          t = startTs + rand() * duration;
        }
        const qty = Math.min(remaining, rand() < 0.3 ? 2 : 1);
        events.push({ t: t, qty: qty });
        remaining -= qty;
      }
      events.sort((a, b) => a.t - b.t);
      return events;
    }
    tick() {
      if (!this.schedule || !this.numEl) return;
      const now = Date.now();

      let consumed = 0;
      for (let i = 0; i < this.schedule.length; i++) {
        if (this.schedule[i].t <= now) consumed += this.schedule[i].qty;
        else break;
      }
      if (now >= this.endTs) consumed = this.startCount;
      const remaining = Math.max(0, this.startCount - consumed);

      const currentShown = parseInt(this.numEl.textContent, 10);
      if (currentShown !== remaining) {
        this.numEl.textContent = remaining;
        this.numEl.classList.remove('offer-bump');
        // force reflow so the animation restarts
        void this.numEl.offsetWidth;
        this.numEl.classList.add('offer-bump');
      }

      // Sleep until the next scheduled drop, clamped to [1s, 60s].
      let nextMs = 60000;
      for (let i = 0; i < this.schedule.length; i++) {
        if (this.schedule[i].t > now) {
          nextMs = Math.min(nextMs, this.schedule[i].t - now + 50);
          break;
        }
      }
      if (now >= this.endTs) return;
      nextMs = Math.max(1000, Math.min(nextMs, 60000));
      this.tickTimer = setTimeout(() => this.tick(), nextMs);
    }
    disconnectedCallback() {
      if (this.tickTimer) clearTimeout(this.tickTimer);
    }
    static hash32(str) {
      let h = 5381;
      for (let i = 0; i < str.length; i++) {
        h = ((h << 5) + h + str.charCodeAt(i)) | 0;
      }
      return h >>> 0;
    }
    static mulberry32(seed) {
      let s = seed >>> 0;
      return function () {
        s = (s + 0x6D2B79F5) | 0;
        let t = s;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }
  }
  customElements.define('offer-counter', OfferCounter);
}
